import React, {useCallback, useEffect, useState} from 'react'
import {CFComponentProps} from 'module/CustomField/type/CFComponentType'
import {CFValue} from 'module/CustomField/type/CFType'
import Select from 'react-select'
import {getReactSelectDefaultProps} from 'config/react-select'
import {ReactSelectSingleValue} from 'module/CustomField/component/input/ReactSelectComponent/ReactSelectSingleValue'
import {CustomFieldSelectOption} from 'module/CustomField/component/input/ReactSelectComponent/CustomFieldSelectOption'
import {isDqSearchable} from 'module/Dq/searchDq'
import {filterOptionReactSelect} from 'module/CustomField/component/input/ReactSelectComponent/FilterOption'
import {useDqSearchRx} from 'module/CustomField/component/input/hook/useDqSearchRx'
import {log} from 'common/log'
import {useMemoDq} from 'module/Memo/hook/useMemoDq'

export function CustomFieldDqLabelComponent(props: CFComponentProps<CFValue>) {
	const {disabled, modelValue, model, cfDef, pos, setCb} = props
	const {searchSubject, loading, labelCache, suggestions} = useDqSearchRx({
		cfDef,
		model,
		pos,
		valueBeforeLabel: false,
	})
	const [inputValue, setInputValue] = useState('')
	const {memoElements, dispatchMemoAutoAddAction, dispatchMemoToggleAction} = useMemoDq({cfDef, modelValue, inputValue})

	const onChange = useCallback((o, {action}) => {
		switch (action) {
			case 'select-option':
				setCb(o?.value)
				setInputValue('')
				dispatchMemoAutoAddAction(o)
				break;
			case 'clear':
				setCb(null)
				setInputValue('')
				break;
			case 'create-option':
			case 'deselect-option':
			case 'remove-value':
			case 'pop-value':
			default:
				log.error('unknown action')
		}
	}, [setCb])

	useEffect(() => {
		// ensure modelValue is in labelCache
		if (modelValue && !labelCache[modelValue]) searchSubject.next({searchTerm: modelValue + '', model, onlyLabelCache: true})
	}, [searchSubject, modelValue, model])
	useEffect(() => {
		searchSubject.next({searchTerm: '', model})
	}, [searchSubject, model])

	const onInputChange = useCallback((v: string, {action}) => {
		setInputValue(v)
		switch (action) {
			case 'input-change':
				searchSubject.next({searchTerm: v, model});
				break;
			case 'input-blur':
			case 'menu-close':
				searchSubject.next({searchTerm: '', model})
				break;
			case 'set-value':
				break;
			default:
				log.error('noop', action);
				break;
		}
	}, [searchSubject, model])

	const mv = modelValue ? {value: modelValue, label: labelCache[modelValue], ...(memoElements.some(m => m.value == modelValue) ? {memo: true} : {})} : null

	let found = false
	const options = suggestions.flatMap(o => {
		if (o.value == modelValue) {
			// exact value OR memo values are added later on top
			found = true
			return []
		} else if (memoElements.some(x => x.value == o.value)) {
			return []
		} else {
			return [o]
		}
	})
	options.unshift(...memoElements.filter(x => x.value != modelValue))
	if (found && mv) {
		options.unshift(mv)
	}

	log.trace('dq label field rendered', mv, options, memoElements, suggestions)

	return <Select
		{...getReactSelectDefaultProps({
			components: {
				SingleValue: ReactSelectSingleValue,
				Option: CustomFieldSelectOption,
			},
			placeholder: '',
			isDisabled: disabled,
			isClearable: true,
			options: options,
			isLoading: loading,
			getOptionValue: (o) => o.value,
			getOptionLabel: (o) => o.label || 'Eintrag wird geladen...',
			value: mv,
			onChange: onChange,
			onInputChange: onInputChange,
			filterOption: isDqSearchable(cfDef.dqKey) ? null : filterOptionReactSelect,
			tabSelectsValue: true,
			dispatchMemoToggleAction,
		})}
	/>
}